import { z } from "zod";

export const TokenResultSchema = z.object({
  token: z.string(),
  maxMp3Length: z.number(),
  userName: z.string(),
  eventName: z.string(),
  description: z.string().nullable(),
  eventDate: z.coerce.date(),
});

export type TokenResult = z.infer<typeof TokenResultSchema>;
